import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

const FABRIC_IMAGE = 'https://static.prod-images.emergentagent.com/jobs/af49a006-9be0-463b-96a6-a9914972e5ea/images/52c599b64c5f46a396cb09aca0b8dc28a111ee61abfacf7fe0bfb7a6bd45272b.png';

export default function FilosofiaPage() {
  const { t } = useLang();

  return (
    <div data-testid="filosofia-page" className="min-h-screen bg-[#FAF9F6] pt-24">
      {/* Hero */}
      <section className="px-6 md:px-12 lg:px-24 py-20">
        <div className="max-w-4xl">
          <p className="overline mb-4">{t({ it: 'La Nostra Filosofia', en: 'Our Philosophy' })}</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-tighter text-[#1C1917] mb-8">
            {t({ it: '"Più lo ami e più ti ripaga"', en: '"The more you love it, the more it pays you back"' })}
          </h1>
          <p className="text-lg text-[#1C1917]/70 leading-relaxed max-w-2xl">
            {t({
              it: 'biolosophy nasce da una convinzione semplice: la moda più bella è quella che dura. Creiamo capi biologici ed ecosostenibili, prodotti interamente in Italia, pensati per accompagnarti per anni — e per tornare a vivere quando decidi di lasciarli andare.',
              en: 'biolosophy was born from a simple belief: the most beautiful fashion is the one that lasts. We create organic, eco-sustainable garments, made entirely in Italy, designed to stay with you for years — and to live again when you decide to let them go.',
            })}
          </p>
        </div>
      </section>

      {/* Image */}
      <section className="px-6 md:px-12 lg:px-24 pb-20">
        <img
          src={FABRIC_IMAGE}
          alt={t({ it: 'Tessuti biologici', en: 'Organic fabrics' })}
          className="w-full h-[400px] md:h-[500px] object-cover"
        />
      </section>

      {/* CTA */}
      <section className="bg-[#1C1917] text-white px-6 md:px-12 lg:px-24 py-20">
        <div className="max-w-3xl">
          <h2 className="text-base md:text-lg font-medium mb-4 uppercase tracking-widest text-[#4A5D23]">
            {t({ it: 'Il nostro impegno', en: 'Our commitment' })}
          </h2>
          <p className="text-2xl md:text-3xl font-light leading-relaxed mb-8">
            {t({
              it: '"Ogni capo che produciamo è un investimento nel futuro: tuo e del pianeta."',
              en: '"Every garment we make is an investment in the future: yours and the planet\'s."',
            })}
          </p>
          <Link
            to="/shop"
            data-testid="filosofia-shop-cta"
            className="inline-flex items-center gap-2 text-white border-b border-white pb-1 hover:text-[#4A5D23] hover:border-[#4A5D23] transition-colors"
          >
            {t({ it: 'Scopri la collezione', en: 'Discover the collection' })}
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
